import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

import { getEntityAndName } from "./utils";

export const ObjectTitle = ({
  k,
  data,
  action,
}: {
  k: string;
  data: any;
  action: string;
}) => {
  const { entity, name } = getEntityAndName(k, data);

  return entity ? (
    <IgTypography>
      <IgTypography>{entity}</IgTypography>
      <IgTypography sx={{ fontWeight: 600 }}>{name}</IgTypography>
      <IgTypography> {action}</IgTypography>
    </IgTypography>
  ) : (
    <IgTypography>
      <IgTypography sx={{ fontWeight: 600 }}>{name}</IgTypography>
      <IgTypography> {action}</IgTypography>
    </IgTypography>
  );
};
